import React, { useState, useEffect, useContext } from "react";
import { ButtonComponent } from "../elements";
import { TranslatorContext } from "../../context/Translator";
import { Modal } from "react-bootstrap";
import { deleteTeam } from "../../APIs/TeamRequests";


export default function TeamsTableComponent({ thead, tbody,refreshPage }) {
    const { t } = useContext(TranslatorContext);


    const [data, setData] = useState([]);
    const [alertModal, setAlertModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    useEffect(()=> { setData(tbody) }, [tbody]);

    const handleDelete = (item) => {
        deleteTeam(item.id).then((res) => {
            setAlertModal(false);
            refreshPage();
        });
    }

    return (
        <div className="mc-table-responsive">
            <table className="mc-table">
                <thead className="mc-table-head primary">
                    <tr>
                        {thead.map((item, index) => (
                            <th key={ index }>{ item }</th>
                        ))}
                    </tr>
                </thead>
                <tbody className="mc-table-body even">
                    {data?.map((item, index) => (
                        <tr key={ index }> 
                            <td title={ item.name }>
                                <div className="mc-table-profile">
                                    <p>{ item.name }</p>
                                </div>
                            </td>

                            <td title={ item.created_at }>{ item.created_at }</td>
                            <td>
                                <div className="mc-table-action">
                                    {/* <AnchorComponent to="/user-profile" title="View" className="material-icons view">{ "visibility" }</AnchorComponent> */}
                                    <ButtonComponent title="Edit" className="material-icons edit" onClick={()=> window.location.href="/team/"+item.id}>{ "edit" }</ButtonComponent>
                                    <ButtonComponent title="Delete" className="material-icons delete" onClick={() => {setAlertModal(true); setSelectedItem(item)}}>{ "delete" }</ButtonComponent>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

           <Modal show={ alertModal } onHide={()=> {setAlertModal(false); setSelectedItem(null)}} centered>
                <div className="mc-alert-modal">
                    <i className="material-icons">new_releases</i>
                    <h3>{t('are you sure?')}</h3>
                    <p>{t('Want to delete this team?')}</p>
                    <Modal.Footer>
                        <ButtonComponent type="button" className="btn btn-secondary" onClick={()=> {setAlertModal(false); setSelectedItem(null)}}>{t('close')}</ButtonComponent>
                        <ButtonComponent type="button" className="btn btn-danger" onClick={()=> handleDelete(selectedItem)}>{t('delete')}</ButtonComponent>
                    </Modal.Footer>
                </div>
            </Modal>
            
        </div>
    )
}